export default __webpack_public_path__ + "static/media/ari.ef99d848.jpg";